'use client'

import React, { useEffect, useState } from "react";
import LoginLogoutMenu from "./LoginLogoutMenu";
import Link from 'next/link';
import { usePathname,  } from 'next/navigation'
import { LoginLogoutMenuProps } from './LoginLogoutMenu';
import usePwaStatus from "@/helpers/usePwaStatus";
import SvgIcons from "./SvgIcons";
import "./Header.css";


interface HeaderProps extends LoginLogoutMenuProps {
    redirect?: string | null;
    setDoneRedirection?: () => void;
    shrinkAtStartRoutes?: string[];
    autoShrink?: boolean;
}

const { ReorderIcon } = SvgIcons();

const Header = ({ profile, logIn, logOut, shrinkAtStartRoutes = [], autoShrink = true } : HeaderProps) => {
    const { isPWA } = usePwaStatus();
    const [expandNavbar, setExpandNavbar] = useState(false);
    const [scrollPosition, setScrollPosition] = useState(0);
    const [width, setWidth] = useState(0);
    const pathname = usePathname();
    const navbarClass = 'navbar';

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    useEffect(() => {
        setExpandNavbar(false);
    }, [pathname]);

    useEffect(() => {
        if (autoShrink) {
            if (scrollPosition > 50) {
                document.getElementsByClassName('navbar')[0]?.classList.add('shrink');
            } else {
                document.getElementsByClassName('navbar')[0]?.classList.remove('shrink');
            }
        }
    }, [scrollPosition, autoShrink]);

    useEffect(() => {
        if (width > 650) {
            setExpandNavbar(false);
        } else {
        }
    }, [width]);

    const handleScroll = () => {
        const position = window.scrollY;
        setScrollPosition(position);
    };

    const handleResize = () => {
        setWidth(window.innerWidth);
    }

    if (isPWA) {
        return <></>;
    }

    return (
        <div className={`${navbarClass} ${shrinkAtStartRoutes.findIndex((sw) => pathname?.startsWith(sw)) !== -1 ? 'shrink' : ''}`} id={expandNavbar ? 'open' : 'close'}>
            <div className="toggleButton">
                <button
                    onClick={() => {
                        setExpandNavbar((prev) => !prev);
                    } }>
                    <ReorderIcon />
                </button>
            </div>
            <div className="menuContainer">
                <div className="links">
                    <Link href="/" prefetch={true} className="thehooman" id="thehoomanlink">
                        <img src='/assets/image/RepulsiveCoder.webp' id="thehooman" alt="thehooman" />
                    </Link>
                    <Link href="/" prefetch={true} className={pathname! === '/' ? 'active' : ''}> Home </Link>
                    <Link href="/projects" prefetch={true} className={pathname?.startsWith('/project') ? 'active' : ''}> Projects </Link>
                    <Link href="/education" prefetch={true} className={pathname?.startsWith('/education') ? 'active' : ''} id='educationTopMenu'> Education </Link>
                    <Link href="/work" prefetch={true} className={pathname?.startsWith('/work') ? 'active' : ''} id='workTopMenu'> Work </Link>
                    <Link href="/skills-and-trainings" prefetch={true} className={pathname?.startsWith('/skills-and-trainings') ? 'active' : ''}> Skills & Trainings</Link>
                    <Link href="/games" prefetch={true} className={pathname?.startsWith('/game') ? 'active' : ''}> Games </Link>
                    <Link href="/blog" prefetch={true} className={pathname?.startsWith('/blog') ? 'active' : ''}> Blog </Link>
                </div>
            </div>
            <div className="loginLogoutMenu">
                <LoginLogoutMenu profile={profile} logIn={logIn} logOut={logOut} />
            </div>
        </div>
    );
}

export default Header;
